import React from "react";
import { aboutContent, LINKS } from "../data/mockData";

const About = () => {
  return (
    <div className="bg-[radial-gradient(circle_at_15%_25%,rgba(59,130,246,0.22),transparent_32%),radial-gradient(circle_at_85%_20%,rgba(167,139,250,0.18),transparent_32%),radial-gradient(circle_at_50%_80%,rgba(134,239,172,0.18),transparent_35%)] min-h-screen">
      {/* Page Header */}
      <div className="bg-gradient-to-r bg-blue-950 py-16 text-center">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-white mb-4 tracking-wider">
          ABOUT
        </h1>
        <div className="w-32 sm:w-48 h-1 bg-blue-600 mx-auto"></div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
        {/* About Conference Section */}
        <section className="mb-20">
          <div className="bg-gradient-to-r from-blue-300 to-blue-200 p-6 sm:p-8 mb-8 text-center rounded-lg border-l-4 border-primary-600">
            <a
              href={LINKS.ABOUT_CONFERENCE}
              target="_blank"
              rel="noopener noreferrer"
            >
              <h2 className="text-3xl font-bold text-blue-950 hover:underline">
                {aboutContent.aboutConference.title}
              </h2>
            </a>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <a
                href={LINKS.ABOUT_CONFERENCE}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={aboutContent.aboutConference.image}
                  alt="Integral University"
                  className="w-full h-80 object-cover rounded-xl shadow-2xl hover:scale-105 transition-transform duration-300 border-4 border-primary-200"
                />
              </a>
            </div>

            <div>
              <p className="text-lg leading-relaxed text-gray-700 text-justify">
                {aboutContent.aboutConference.text}
              </p>
            </div>
          </div>
        </section>

        {/* Integral University Section */}
        <section className="mb-20">
          <div className="bg-gradient-to-r from-blue-300 to-blue-200 p-6 sm:p-8 mb-8 text-center rounded-lg border-l-4 border-primary-600">
            <a
              href={LINKS.INTEGRAL_UNIVERSITY}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block hover:opacity-90 transition cursor-pointer"
            >
              <h2 className="text-3xl font-bold text-blue-950 hover:underline">
                {aboutContent.integralUniversity.title}
              </h2>
            </a>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <a
                href={LINKS.INTEGRAL_UNIVERSITY}
                target="_blank"
                rel="noopener noreferrer"
                className="block cursor-pointer"
              >
                <img
                  src={aboutContent.integralUniversity.image}
                  alt="Integral University"
                  className="w-full h-80 object-cover rounded-xl shadow-2xl hover:scale-105 transition-transform duration-300 border-4 border-primary-200"
                />
              </a>
            </div>

            <div>
              <p className="text-lg leading-relaxed text-gray-700 text-justify">
                {aboutContent.integralUniversity.text}
              </p>
            </div>
          </div>
        </section>

        {/* Lucknow Chapter Section */}
        <section className="mb-20">
          <div className="bg-gradient-to-r from-blue-300 to-blue-200 p-6 sm:p-8 mb-8 text-center rounded-lg border-l-4 border-primary-600">
            <a
              href={LINKS.LUCKNOW_CHAPTER}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block hover:opacity-90 transition cursor-pointer"
            >
              <h2 className="text-3xl font-bold text-blue-950 hover:underline">
                {aboutContent.lucknowChapter.title}
              </h2>
            </a>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <a
                href={LINKS.LUCKNOW_CHAPTER}
                target="_blank"
                rel="noopener noreferrer"
                className="block cursor-pointer"
              >
                <img
                  src={aboutContent.lucknowChapter.image}
                  alt="Lucknow Chapter"
                  className="w-full h-80 object-cover rounded-xl shadow-2xl hover:scale-105 transition-transform duration-300 border-4 border-primary-200"
                />
              </a>
            </div>

            <div className="order-1 lg:order-2">
              <p className="text-lg leading-relaxed text-gray-700 text-justify">
                {aboutContent.lucknowChapter.text}
              </p>
            </div>
          </div>
        </section>

        {/* CSIR-CBRI Section */}
        <section className="mb-20">
          <div className="bg-gradient-to-r from-blue-300 to-blue-200 p-6 sm:p-8 mb-8 text-center rounded-lg border-l-4 border-primary-600">
            <a
              href={LINKS.CSIR_CBRI}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block hover:opacity-90 transition cursor-pointer"
            >
              <h2 className="text-3xl font-bold text-blue-950 hover:underline">
                {aboutContent.csirCbri.title}
              </h2>
            </a>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <a
                href={LINKS.CSIR_CBRI}
                target="_blank"
                rel="noopener noreferrer"
                className="block cursor-pointer"
              >
                <img
                  src={aboutContent.csirCbri.image}
                  alt="CSIR-CBRI"
                  className="w-full h-80 object-cover rounded-xl shadow-2xl hover:scale-105 transition-transform duration-300 border-4 border-primary-200"
                />
              </a>
            </div>

            <div>
              <p className="text-lg leading-relaxed text-gray-700 text-justify">
                {aboutContent.csirCbri.text}
              </p>
            </div>
          </div>
        </section>

        {/* CSIR-CRRI Section */}
        <section className="mb-20">
          <div className="bg-gradient-to-r from-blue-300 to-blue-200 p-6 sm:p-8 mb-8 text-center rounded-lg border-l-4 border-primary-600">
            <a
              href={LINKS.CSIR_CRRI}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block hover:opacity-90 transition cursor-pointer"
            >
              <h2 className="text-3xl font-bold text-blue-950 hover:underline">
                {aboutContent.csirCrri.title}
              </h2>
            </a>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <a
                href={LINKS.CSIR_CRRI}
                target="_blank"
                rel="noopener noreferrer"
                className="block cursor-pointer"
              >
                <img
                  src={aboutContent.csirCrri.image}
                  alt="CSIR-CRRI"
                  className="w-full h-80 object-cover rounded-xl shadow-2xl hover:scale-105 transition-transform duration-300 border-4 border-primary-200"
                />
              </a>
            </div>

            <div>
              <p className="text-lg leading-relaxed text-gray-700 text-justify">
                {aboutContent.csirCrri.text}
              </p>
            </div>
          </div>
        </section>

        {/* Civil Dept Section */}
        <section className="mb-15">
          <div className="bg-gradient-to-r from-blue-300 to-blue-200 p-6 sm:p-8 mb-8 text-center rounded-lg border-l-4 border-primary-600">
            <a
              href={LINKS.CIVIL_DEPT}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block hover:opacity-90 transition cursor-pointer"
            >
              <h2 className="text-3xl font-bold text-blue-950 hover:underline">
                {aboutContent.civilDept.title}
              </h2>
            </a>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <a
                href={LINKS.CIVIL_DEPT}
                target="_blank"
                rel="noopener noreferrer"
                className="block cursor-pointer"
              >
                <img
                  src={aboutContent.civilDept.image}
                  alt="Civil Engineering Department"
                  className="w-full h-80 object-cover rounded-xl shadow-2xl hover:scale-105 transition-transform duration-300 border-4 border-primary-200"
                />
              </a>
            </div>

            <div>
              <p className="text-lg leading-relaxed text-gray-700 text-justify">
                {aboutContent.civilDept.text}
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
